import { Component } from "@/types"
import { cx } from "@/utils/cx"
import { MarketingSection } from "@/ui/blocks/layout/MarketingSection"
import { Title } from "@/ui/atoms/type/Title"
import { ButtonLink } from "@/ui/atoms/controls/ButtonLink"
import { Stack } from "@/ui/atoms/layout/Stack"
export const COMPONENT_NAME = "ctaSection"

export const presets = {}

export interface Props extends Component {}

export function CtaSection({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <Stack
      className={cx(`gap-6 items-center text-center max-w-[720px] mx-auto`, className)}
      testId={testId}
    >
      <Title size="xl" as="h2" className="md:text-[40px] text-white">
        99 of the Fortune 100 employ cybersecurity professionals trained by SANS. Join them.
      </Title>
      <ButtonLink
        href="https://www.sans.org/about/contact/sales"
        label="Get in touch"
        variant="primary"
      />
    </Stack>
  )
}
